import React from 'react';

const SvgOpenLink = (props) => (
  <svg width={'1em'} height={'1em'} viewBox="-5 0 20 13" {...props}>
    <path
      fill="currentColor"
      d="M12.492 12.444H1.602V1.556H6.16V0H1.603C.739 0 .047.7.047 1.556v10.888C.047 13.3.74 14 1.603 14h10.889c.855 0 1.555-.7 1.555-1.556v-4.65h-1.555v4.65zM8.602 0v1.556h2.793L3.749 9.2l1.097 1.097 7.646-7.646v2.792h1.555V0H8.603z"
    />
  </svg>
);

export default SvgOpenLink;
